import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { Box } from "@mui/material";

import { CurrencyCode } from "Infrastructure/Models/CurrencyCodes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import { useReportingKpisQuery } from "Reporting/Api/Queries/useReportingKpisQuery";
import { useReportingProjectsQuery } from "Reporting/Api/Queries/useReportingProjectsQuery";
import { KpiCard } from "./KpiCard";

export const ReportingKpis = (): React.ReactNode => {
  const { t } = useResource();

  const { data: kpis, isLoading: kpisLoading } = useReportingKpisQuery();
  const { data: projects, isLoading: projectsLoading } =
    useReportingProjectsQuery();

  return (
    <Box
      sx={{
        display: "grid",
        gap: 3,
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(4, 1fr)",
          lg: "repeat(7, 1fr)",
        },
      }}
    >
      <KpiCard
        title={t(Resources.Reporting.RevenueThisMonth)}
        value={formatCurrency(kpis?.revenueThisMonth, CurrencyCode.EUR, 0)}
        icon={<TrendingUpIcon />}
        isLoading={kpisLoading}
      />
      <KpiCard
        title={t(Resources.Reporting.ActiveProjects)}
        value={kpis?.activeProjectsCount ?? 0}
        icon={<FolderOpenOutlinedIcon />}
        isLoading={kpisLoading}
      />
      <KpiCard
        title={t(Resources.Reporting.NewPartnersThisMonth)}
        value={kpis?.newPartnersThisMonth ?? 0}
        icon={<HandshakeOutlinedIcon />}
        isLoading={kpisLoading}
      />
      <KpiCard
        title={t(Resources.Reporting.JobsThisMonth)}
        value={kpis?.jobsThisMonth ?? 0}
        icon={<WorkOutlineIcon />}
        isLoading={kpisLoading}
      />
      <KpiCard
        title={t(Resources.Reporting.AverageJobCost)}
        value={
          projects?.averageJobCost != null
            ? formatCurrency(projects.averageJobCost, CurrencyCode.EUR, 0)
            : "--"
        }
        icon={<PaidOutlinedIcon />}
        isLoading={projectsLoading}
      />
      <KpiCard
        title={t(Resources.Reporting.AverageCompletionTime)}
        value={
          projects?.averageCompletionDays != null
            ? `${Math.round(projects.averageCompletionDays * 10) / 10} ${t(Resources.Reporting.Days)}`
            : "--"
        }
        icon={<AccessTimeOutlinedIcon />}
        isLoading={projectsLoading}
      />
      <KpiCard
        title={t(Resources.Reporting.AverageActorApprovalTime)}
        value={
          kpis?.averageActorApprovalDays != null
            ? `${Math.round(kpis.averageActorApprovalDays * 10) / 10} ${t(Resources.Reporting.Days)}`
            : "--"
        }
        icon={<HowToRegOutlinedIcon />}
        isLoading={kpisLoading}
      />
    </Box>
  );
};
